export default "__VITE_ASSET__4fc25f9d__"